import { Button } from '@material-ui/core'
import styled, { css } from 'styled-components'

import theme from '../../../utils/theme'
import Icon from '../../Icon'

function PageHeader(props) {
  const currentLocation = typeof window !== 'undefined' ? window.location : { pathname: '' }
  const browserHistory = typeof window !== 'undefined' ? window.history : null

  const {
    buttons,
    className,
    children,
    heading,
    subHeading,
    bigSubHeading,
    linkText,
    linkPath,
    isDetailed,
    // biome-ignore lint/correctness/noUnusedVariables: legacy destructured prop
    others,
    onClick,
    useImage,
    profileImage,
    rightContent,
    backButtonOnClick,
  } = props

  const goBack = () => {
    if (backButtonOnClick) {
      backButtonOnClick(browserHistory, currentLocation)
    } else if (browserHistory) {
      browserHistory.back()
    }
  }

  return (
    <Header className={className} isDetailed={isDetailed}>
      {profileImage && <LeftImage>{profileImage}</LeftImage>}
      <StyledContent>
        <ActionRow>
          {linkPath ? (
            <BackButton component="a" href={linkPath} aria-label="Back" themeMode={themeMode}>
              <Icon iconName="backButtonArrow" iconSize={12} />
              {linkText || 'Back'}
            </BackButton>
          ) : null}
          {isDetailed && (browserHistory ? browserHistory.length > 1 : false) ? (
            <BackButton
              onClick={onClick ? () => onClick(goBack) : goBack}
              title="Back to previous page"
              aria-label="Back to previous Page"
            >
              <Icon iconName="backButtonArrow" iconSize={12} />
              {linkText || 'Back'}
            </BackButton>
          ) : null}
          {buttons ? <Buttons>{buttons}</Buttons> : null}
        </ActionRow>
        <Content>
          <LeftContent hasRight={rightContent}>
            {useImage ? (
              <img src={useImage} alt={heading} />
            ) : (
              // biome-ignore lint/complexity/noUselessFragments: TODO
              <>
                <Title>
                  {heading} {subHeading && <SubTitle big={bigSubHeading}>{subHeading}</SubTitle>}
                </Title>
              </>
            )}
            {children}
          </LeftContent>
          {rightContent && <RightContent>{rightContent}</RightContent>}
        </Content>
      </StyledContent>
    </Header>
  )
}

const Header = styled.header`
  display: flex;
  flex-direction: row;
  margin-bottom: ${props => (props.isDetailed ? '30px' : '40px')};
  img {
    height: 60px;
    width: auto;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: no-wrap;
  justify-content: space-between;
`

const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 2;
  align-items: flex-start;
  ${props =>
    !props.rightContent &&
    css`
      width: 100% !important;
    `}
`

const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-self: flex-end;
`

const LeftImage = styled.div`
  margin-right: 1em;
  height: 100px;
  width: 100px;
`

const StyledContent = styled.div`
  width: 100%;
`

const Title = styled.h1`
  font-size: 1.25rem;
  @media (min-width: 769px) {
    font-size: 1.3125rem;
  }
  white-space: wrap;
  text-overflow: ellipsis;
  font-weight: ${theme.typography.fontWeightBold};
  color: ${`var(--gameday-body-headingColor, ${theme.body.headingColor})`};
  margin: 0 0 8px;
  word-break: break-word;
`

const SubTitle = styled.span`
  color: var(--gameday-body-textColorAlt, ${theme.body.textColorAlt});
  font-weight: ${theme.typography.fontWeightBold};
  padding-left: 0.5em;

  ${props =>
    !props.big &&
    css`
      font-size: 70%;
      font-weight: ${theme.typography.fontWeightNormal};
    `}
`

const ActionRow = styled.div`
  width: 100%;
  margin: 0 0 12px;
  &:empty {
    display: none;
  }
`

const BackButton = styled(Button)`
  && {
    border: ${theme.borders.default};
    color: ${`var(--gameday-buttons-backButtonColor, ${theme.buttons.backButtonColor})`};
    background-color: ${`var(--gameday-buttons-backButtonBg, ${theme.buttons.backButtonBg})`};
    min-width: auto;
    height: 30px;
    padding: 1px 14px 0;
    font-size: 13px;
    font-weight: normal;

    .custom-icon {
      margin-right: 9px;
    }

    &:hover {
      background-color: var(--gameday-buttons-backButtonBgHover, ${theme.buttons.backButtonBgHover});
      color: var(--gameday-buttons-backButtonColorHover, inherit);
    }
  }
`

const Buttons = styled.div`
  float: right;
  & > button {
    margin-left: ${theme.spacing(2)};
  }
`

export default PageHeader
